function StatusIcon({ status, aquamationType, returnLogistics }) {
  const getReadyStatusLabel = (aquamationType, returnLogistics) => {
    if (aquamationType === "Scattering Service") {
      return "Ready for scattering";
    }

    if (aquamationType === "Private" || aquamationType === "Remains Returned") {
      const logisticsLabels = {
        "Return to practice": "Ready for delivery to practice",
        "Return to primary care clinic":
          "Ready for delivery to primary care clinic",
        "Ship to pet family": "Ready for shipping",
        "Pick up from Resting Waters": "Ready for pickup at Resting Waters",
      };
      return (
        logisticsLabels[returnLogistics] ||
        "Ready for pickup/dropoff/scattering"
      );
    }

    return "Ready for pickup/dropoff/scattering";
  };

  const getCompleteStatusLabel = (aquamationType, returnLogistics) => {
    if (aquamationType === "Scattering Service") {
      return "Scattering complete";
    }

    if (aquamationType === "Private" || aquamationType === "Remains Returned") {
      const logisticsLabels = {
        "Return to practice": "Returned to practice",
        "Return to primary care clinic": "Returned to primary care clinic",
        "Ship to pet family": "Shipped to pet family",
        "Pick up from Resting Waters": "Picked up at Resting Waters",
      };
      return logisticsLabels[returnLogistics] || "Returned to customer";
    }

    return "Complete";
  };

  const STATUS_CONFIG = {
    "To Be Received": { class: "button-red-500", label: "To Be Received" },
    Received: { class: "button-blue-700", label: "Received" },
    Collected: { class: "button-blue-700", label: "Received" },
    Processing: { class: "button-green-300", label: "Processing" },
    Finishing: { class: "button-yellow-900", label: "Finishing" },
    "Quality Check": { class: "button-yellow-900", label: "Finishing" },
    "Ready for Pickup/Dropoff/Scattering": {
      class: "button-yellow-900",
      getLabel: getReadyStatusLabel,
    },
    Complete: { class: "", getLabel: getCompleteStatusLabel },
  };

  const statusClass = STATUS_CONFIG[status]?.class;
  const statusLabel = STATUS_CONFIG[status]?.getLabel
    ? STATUS_CONFIG[status].getLabel(aquamationType, returnLogistics)
    : STATUS_CONFIG[status]?.label || "Finishing";

  return (
    <div className={`button button-status ${statusClass}`}>{statusLabel}</div>
  );
}

export default StatusIcon;
